var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6da544",
    d: "M0 512h167l37.9-260.3L167 0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M512 0H167v512h345z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 256,
    r: 89,
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M116.9 211.5V267a50 50 0 1 0 100.1 0v-55.6H117z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M167 283.8c-9.2 0-16.7-7.5-16.7-16.7V245h33.4v22c0 9.2-7.5 16.7-16.7 16.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.12b7f0191ec2f50948d4791833f7b71a.svg";
export { ForwardRef as ReactComponent };